import { AfterContentChecked, AfterViewChecked, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiProjectTypeService } from '../../shared/services/api-project-type.service';
import { StepperServiceService } from '../../shared/services/stepper-service.service';
import { RemoveDialogComponent } from '../remove-dialog/remove-dialog.component';
import { LanguageService } from '../../shared/services/language.service';
import { TecnologiasService } from '../../shared/services/tecnologias.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProjectTypesService } from '../../shared/services/project-types.service';
import { UsersManagementService } from 'src/app/modules/shared/services/usersManagement.service';
import { AuthService } from '../../shared/services/auth.service';
import { AddTipoProjetoDialogComponent } from '../add-tipo-projeto-dialog/add-tipo-projeto-dialog.component';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';
import { Permission } from '../../shared/security/permission';


@Component({
  standalone: false,
  selector: 'app-tipo-projeto',
  templateUrl: './tipo-projeto.component.html',
  styleUrls: ['./tipo-projeto.component.css']
})
export class TipoProjetoComponent implements OnInit {

  Permission = Permission
  variables: any;
  arr1: any = [];


  // Form and sub form. It is needed to link parent form with this component form.
  form: any;
  @Input() canEditCatalog: boolean = false;
  subForm: any;
  private sub: Subscription | undefined = undefined;
  tecnologia: any; //Which technology is being created or edited.
  isListEmpty: boolean = false;


  @Input() listItem: any[] = []; //List of project types choosen by the user.


  preDefinedProjectTypes: any[] = []; //Predefined list of project types
  alreadyInCatalog: any[] = []; //List of project types already in catalog


  constructor(private _formBuilder: FormBuilder,
    private ctrlContainer: FormGroupDirective,
    private stepperService: StepperServiceService,
    public authService: AuthService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private projectTypeService: ApiProjectTypeService,
    private techService: TecnologiasService,
    private languageService: LanguageService,
    private _snackBar: MatSnackBar,
    private infoBar: InfoBarWithStatusService,
    private projectTypesService: ProjectTypesService,
    private UsersManagementService: UsersManagementService,
  ) { }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    //Link sub form and form
    this.subForm = this._formBuilder.group({
      projectType: [''],
    });

    this.form = this.ctrlContainer.form;
    this.form.addControl("formGroup1", this.subForm);
    this.subForm.status = "INVALID";
    this.form.status = "INVALID";
  }

  ngOnChanges(changes: SimpleChanges) {

    if (this.variables) {
      this.preDefinedProjectTypes = [
        { name: this.variables.fixedPrice, value: 10 },
        { name: this.variables.tm, value: 8 },
        { name: this.variables.other, value: null }
      ];
    }

    this.alreadyInCatalog = changes.listItem.currentValue
  }

  openDialogProject() {
    var arrAll;
    this.arr1 = [];
    arrAll = this.listItem;

    for (var i = 0; i < arrAll.length; i++) {
      this.arr1.push(arrAll[i].name);
    }

    // Prepare data to be passed to dialog component
    const data = {
      title: this.variables.addProjectType,
      list: this.preDefinedProjectTypes,
      listInCatalog: this.alreadyInCatalog,
      isEdit: false,
      isActionType: false,
      effort: "%",
      isProjectType: true
    }
    let dialogRef = this.dialog.open(AddTipoProjetoDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      //Add item to array
      if (result) {

        if (this.arr1.includes(result.data.name)) {
          this._snackBar.open(this.variables.snackBarErrorAddProjectType);
        }
        else {
          const projectType = {
            name: result.data.name,
            risk: result.data.risk.toFixed("2")
          }

          this.listItem.push(projectType);
          this.projectTypesService.setListItem(this.listItem);
          this.isListEmpty = false;
        }

      }
    });
  }


  openDialogEditProject(item: any) {
    var arrAll;
    this.arr1 = [];
    arrAll = this.listItem;

    for (var i = 0; i < arrAll.length; i++) {
      this.arr1.push(arrAll[i].name);
    }

    const index = this.arr1.indexOf(item.name);
    if (index !== -1) {
      this.arr1.splice(index, 1);
    } else {
    }

    //Prepare data to be passed to dialog component
    item.title = this.variables.changeProjectType + ': ' + item.name
    const data = {
      title: item.title,
      list: this.preDefinedProjectTypes,
      listInCatalog: this.alreadyInCatalog,
      isEdit: true,
      item: item,
      itemIndex: index,
      effort: "%",
      isActionType: false,
      isProjectType: true
    }

    let dialogRef = this.dialog.open(AddTipoProjetoDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {


      // Get result and update item on the arr
      if (result?.data) {

        if (this.arr1.includes(result.data.name)) {
          this._snackBar.open(this.variables.snackBarErrorEditProjectType);
        }
        else {
          this.listItem.forEach(v => {
            if (v.name === item.name && v.risk === item.risk) {
              v.name = result.data.name;
              v.risk = result.data.risk.toFixed("2");
            }
          })
          this.projectTypesService.setListItem(this.listItem);
          this.infoBar.showSnackbar(this.variables.projectTypeChanged, ['successful-snackbar'], 4000);

        }
      }

    })
  }


  openDialogRemove(name: string) {
    let dialogRef = this.dialog.open(RemoveDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      // Remove item
      if (result === 'true') {
        this.listItem = this.listItem.filter(item => {
          return item.name != name;
        })

        if (this.listItem.length === 0) this.isListEmpty = true;
        this.projectTypesService.setListItem(this.listItem);

        this.infoBar.showSnackbar(this.variables.projectTypeRemoved, ['successful-snackbar'], 4000);
      }
    });
  }

}
